// extracted by mini-css-extract-plugin
export default {"root":"JoinWaitlist_root__fxxAD","description":"JoinWaitlist_description__k+4VU","title":"JoinWaitlist_title__lc55D","closeButton":"JoinWaitlist_closeButton__KYJFW"};